
import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedinIn,
  FaGraduationCap,
  FaArrowRight,
  FaQuoteLeft,
  FaAward,
  FaUsers,
  FaBookOpen,
  FaHeart,
} from "react-icons/fa";

import principalImage from "./daddymark.jpg";
import vicePrincipalImage from "./patrick.jpg";
import deanImage from "./patrick.jpg";

const schoolLeadershipTeam = [
  {
    id: "principal",
    image: principalImage,
    name: "Mrs. Cecelia Freeman",
    role: "Principal",
    description:
      "Dedicated to providing visionary leadership, promoting academic excellence, and building a supportive learning environment where every student is encouraged to reach their full potential.",
    email: "principal@messiahmission.edu",
    phone: "",
    linkedin: "",
    initials: "CF",
  },
  {
    id: "vice-principal",
    image: vicePrincipalImage,
    name: "Mr. Samuel T. Gbondo",
    role: "Vice Principal",
    description:
      "Committed to strengthening educational programs, empowering teachers, and ensuring that every learner receives the guidance and support needed to thrive.",
    email: "bondosamuel97@gmail.com",
    phone: "",
    linkedin: "",
    initials: "SG",
  },
  {
    id: "dean",
    image: deanImage,
    name: "Mr. Andrew P. Makor",
    role: "Dean of Students",
    description:
      "Focused on student welfare, discipline, personal development, and leadership, fostering a respectful school community where every student belongs.",
    email: "andrewmakor6@gmail.com",
    phone: "",
    linkedin: "",
    initials: "AM",
  },
];

const foundationStyles = `
  .jlw-leadership,
  .jlw-leadership * {
    box-sizing: border-box;
  }

  .jlw-leadership {
    --jlw-navy: #112746;
    --jlw-navy-dark: #09182d;
    --jlw-gold: #c79b45;
    --jlw-gold-light: #f3e6c9;
    --jlw-ink: #1c2b40;
    --jlw-muted: #6c7788;
    --jlw-border: #e8ebf0;
    --jlw-white: #ffffff;

    position: relative;
    width: 100%;
    overflow: hidden;
    background: #ffffff;
    color: var(--jlw-ink);
    font-family: inherit;
  }

  .jlw-leadership a {
    text-decoration: none;
  }

  .jlw-leadership a:focus-visible {
    outline: 3px solid var(--jlw-gold);
    outline-offset: 4px;
  }

  /* HERO */

  .jlw-hero {
    position: relative;
    isolation: isolate;
    display: flex;
    align-items: center;
    min-height: 400px;
    padding: 85px 24px 100px;
    overflow: hidden;
    background:
      radial-gradient(
        circle at 85% 20%,
        rgba(199, 155, 69, 0.2),
        transparent 30%
      ),
      linear-gradient(
        120deg,
        #09182d 0%,
        #112746 58%,
        #203d60 100%
      );
  }

  .jlw-hero::before,
  .jlw-hero::after {
    position: absolute;
    z-index: -1;
    content: "";
    pointer-events: none;
    border: 1px solid rgba(243, 230, 201, 0.15);
    border-radius: 50%;
  }

  .jlw-hero::before {
    width: 480px;
    height: 480px;
    top: -245px;
    right: -75px;
  }

  .jlw-hero::after {
    width: 330px;
    height: 330px;
    top: -170px;
    right: 0;
  }

  .jlw-hero-inner {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  .jlw-hero-copy {
    max-width: 780px;
    animation: jlwFadeUp 0.75s ease both;
  }

  .jlw-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 23px;
    color: #f0d9a7;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 2.8px;
    line-height: 1.6;
    text-transform: uppercase;
  }

  .jlw-eyebrow::before {
    width: 32px;
    height: 2px;
    flex-shrink: 0;
    content: "";
    background: var(--jlw-gold);
  }

  .jlw-hero h1 {
    max-width: 760px;
    margin: 0;
    color: #ffffff;
    font-family: Georgia, "Times New Roman", serif;
    font-size: clamp(39px, 5.2vw, 67px);
    font-weight: 600;
    letter-spacing: -1.8px;
    line-height: 1.13;
  }

  .jlw-hero h1 span {
    display: block;
    margin-top: 5px;
    color: #e8c77f;
    font-style: italic;
  }

  .jlw-hero-description {
    max-width: 650px;
    margin: 24px 0 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 16px;
    line-height: 1.9;
  }

  .jlw-hero-bottom {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 5px;
    background: linear-gradient(
      90deg,
      var(--jlw-gold) 0%,
      #f1dfb7 45%,
      rgba(199, 155, 69, 0.1) 100%
    );
  }

  /* INTRODUCTION */

  .jlw-intro {
    padding: 83px 24px 35px;
    background: #ffffff;
  }

  .jlw-intro-inner {
    display: grid;
    grid-template-columns: 1fr 1.15fr;
    align-items: center;
    gap: 75px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  .jlw-intro-symbol {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 290px;
    padding: 35px;
    overflow: hidden;
    border: 1px solid #eadfc9;
    border-radius: 5px;
    background:
      radial-gradient(
        circle at 20% 20%,
        rgba(199, 155, 69, 0.12),
        transparent 36%
      ),
      #f8f6f1;
  }

  .jlw-intro-symbol::before,
  .jlw-intro-symbol::after {
    position: absolute;
    width: 230px;
    height: 230px;
    content: "";
    border: 1px solid rgba(199, 155, 69, 0.2);
    border-radius: 50%;
  }

  .jlw-intro-symbol::after {
    width: 175px;
    height: 175px;
  }

  .jlw-intro-emblem {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 112px;
    height: 112px;
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 50%;
    background: var(--jlw-navy);
    color: #edcf8b;
    box-shadow: 0 18px 45px rgba(17, 39, 70, 0.18);
    font-size: 45px;
  }

  .jlw-intro-caption {
    position: absolute;
    right: 20px;
    bottom: 18px;
    left: 20px;
    color: #6b624f;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 2.3px;
    text-align: center;
    text-transform: uppercase;
  }

  .jlw-section-label {
    display: block;
    margin-bottom: 15px;
    color: #a67b30;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 2.5px;
    line-height: 1.7;
    text-transform: uppercase;
  }

  .jlw-intro h2,
  .jlw-section-heading h2 {
    margin: 0;
    color: var(--jlw-navy);
    font-family: Georgia, "Times New Roman", serif;
    font-size: clamp(30px, 3.6vw, 43px);
    font-weight: 600;
    letter-spacing: -0.7px;
    line-height: 1.25;
  }

  .jlw-intro-text {
    margin: 19px 0 0;
    color: var(--jlw-muted);
    font-size: 15px;
    line-height: 1.9;
  }

  .jlw-intro-rule {
    width: 58px;
    height: 3px;
    margin-top: 24px;
    background: var(--jlw-gold);
  }

  /* LEADERSHIP */

  .jlw-team-section {
    padding: 75px 24px 100px;
    background:
      linear-gradient(
        180deg,
        #f8f9fb 0%,
        #ffffff 100%
      );
  }

  .jlw-section-heading {
    max-width: 720px;
    margin: 0 auto 48px;
    text-align: center;
  }

  .jlw-section-heading .jlw-section-label {
    margin-bottom: 12px;
  }

  .jlw-section-heading h2 {
    font-size: clamp(32px, 4vw, 45px);
  }

  .jlw-section-heading p {
    max-width: 650px;
    margin: 17px auto 0;
    color: var(--jlw-muted);
    font-size: 15px;
    line-height: 1.9;
  }

  .jlw-team-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: stretch;
    gap: 28px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  .jlw-leader-card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    border: 1px solid #e9ebef;
    border-radius: 5px;
    background: #ffffff;
    box-shadow: 0 8px 30px rgba(17, 39, 70, 0.045);
    transition:
      transform 0.3s ease,
      box-shadow 0.3s ease,
      border-color 0.3s ease;
  }

  .jlw-leader-card:hover {
    transform: translateY(-7px);
    border-color: #dfc58f;
    box-shadow: 0 22px 50px rgba(17, 39, 70, 0.12);
  }

  .jlw-leader-image-wrap {
    position: relative;
    height: 310px;
    overflow: hidden;
    background: #e9edf2;
  }

  .jlw-leader-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 30%;
    transition: transform 0.6s ease;
  }

  .jlw-leader-card:hover .jlw-leader-image {
    transform: scale(1.045);
  }

  .jlw-leader-image-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #112746, #34516f);
    color: #f1d79d;
    font-family: Georgia, "Times New Roman", serif;
    font-size: 64px;
  }

  .jlw-leader-number {
    position: absolute;
    top: 16px;
    left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 50%;
    background: rgba(9, 24, 45, 0.82);
    color: #f0d9a7;
    font-family: Georgia, "Times New Roman", serif;
    font-size: 14px;
  }

  .jlw-leader-role {
    position: absolute;
    right: 13px;
    bottom: 15px;
    left: 13px;
    width: fit-content;
    max-width: calc(100% - 26px);
    padding: 10px 14px;
    border-left: 3px solid var(--jlw-gold);
    background: rgba(9, 24, 45, 0.94);
    color: #ffffff;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1.4px;
    line-height: 1.5;
    text-transform: uppercase;
  }

  .jlw-leader-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 27px 25px 24px;
  }

  .jlw-leader-name {
    margin: 0;
    color: var(--jlw-navy);
    font-family: Georgia, "Times New Roman", serif;
    font-size: 23px;
    font-weight: 600;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .jlw-leader-position {
    margin: 8px 0 0;
    color: #a67b30;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 1.7px;
    line-height: 1.7;
    text-transform: uppercase;
  }

  .jlw-leader-divider {
    width: 43px;
    height: 2px;
    margin: 18px 0;
    background: #e0c58d;
  }

  .jlw-leader-description {
    flex: 1;
    margin: 0;
    color: #697586;
    font-size: 13px;
    line-height: 1.95;
  }

  .jlw-leader-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #edf0f3;
  }

  .jlw-contact-caption {
    color: #687386;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1.3px;
    text-transform: uppercase;
  }

  .jlw-contact-links {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .jlw-contact-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 37px;
    height: 37px;
    flex-shrink: 0;
    border: 1px solid #e5e9ef;
    border-radius: 50%;
    background: #ffffff;
    color: var(--jlw-navy);
    font-size: 13px;
    transition:
      background 0.2s ease,
      border-color 0.2s ease,
      color 0.2s ease,
      transform 0.2s ease;
  }

  .jlw-contact-link:hover {
    transform: translateY(-2px);
    border-color: var(--jlw-navy);
    background: var(--jlw-navy);
    color: #ffffff;
  }

  .jlw-contact-link.jlw-linkedin:hover {
    border-color: #0a66c2;
    background: #0a66c2;
  }

  /* VALUES STRIP */

  .jlw-values {
    padding: 30px 24px;
    background: #ffffff;
  }

  .jlw-values-inner {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    border: 1px solid #e9ebef;
    background: #ffffff;
  }

  .jlw-value {
    display: flex;
    align-items: center;
    gap: 15px;
    min-width: 0;
    padding: 24px 20px;
    border-right: 1px solid #e9ebef;
  }

  .jlw-value:last-child {
    border-right: 0;
  }

  .jlw-value-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 43px;
    height: 43px;
    flex-shrink: 0;
    border-radius: 50%;
    background: #f6efdf;
    color: #a67b30;
    font-size: 17px;
  }

  .jlw-value h3 {
    margin: 0;
    color: var(--jlw-navy);
    font-size: 12px;
    font-weight: 800;
    line-height: 1.6;
  }

  .jlw-value p {
    margin: 3px 0 0;
    color: var(--jlw-muted);
    font-size: 11px;
    line-height: 1.6;
  }

  /* CLOSING MESSAGE */

  .jlw-closing {
    padding: 65px 24px 80px;
    text-align: center;
    background: #f8f6f1;
  }

  .jlw-closing-inner {
    max-width: 760px;
    margin: 0 auto;
  }

  .jlw-quote-icon {
    margin-bottom: 17px;
    color: #c79b45;
    font-size: 25px;
  }

  .jlw-closing h2 {
    margin: 0;
    color: var(--jlw-navy);
    font-family: Georgia, "Times New Roman", serif;
    font-size: clamp(28px, 4vw, 40px);
    font-weight: 600;
    line-height: 1.35;
  }

  .jlw-closing p {
    max-width: 640px;
    margin: 17px auto 0;
    color: var(--jlw-muted);
    font-size: 14px;
    line-height: 1.9;
  }

  .jlw-closing-rule {
    width: 55px;
    height: 3px;
    margin: 25px auto 0;
    background: var(--jlw-gold);
  }

  @keyframes jlwFadeUp {
    from {
      opacity: 0;
      transform: translateY(18px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* TABLETS */

  @media (max-width: 1050px) {
    .jlw-intro-inner {
      grid-template-columns: 0.85fr 1.15fr;
      gap: 40px;
    }

    .jlw-team-grid {
      gap: 18px;
    }

    .jlw-leader-image-wrap {
      height: 270px;
    }

    .jlw-leader-content {
      padding: 23px 19px;
    }

    .jlw-leader-name {
      font-size: 20px;
    }

    .jlw-value {
      gap: 10px;
      padding: 20px 13px;
    }
  }

  @media (max-width: 760px) {
    .jlw-hero {
      min-height: 350px;
      padding: 75px 22px 80px;
    }

    .jlw-hero h1 {
      font-size: clamp(37px, 7vw, 53px);
      letter-spacing: -1px;
    }

    .jlw-hero-description {
      font-size: 14px;
    }

    .jlw-intro {
      padding: 60px 22px 25px;
    }

    .jlw-intro-inner {
      grid-template-columns: 1fr;
      gap: 32px;
    }

    .jlw-intro-symbol {
      min-height: 230px;
    }

    .jlw-intro h2 {
      font-size: 34px;
    }

    .jlw-team-section {
      padding: 60px 22px 70px;
    }

    .jlw-section-heading {
      margin-bottom: 34px;
    }

    .jlw-team-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 18px;
    }

    .jlw-leader-image-wrap {
      height: 270px;
    }

    .jlw-leader-content {
      padding: 21px 17px;
    }

    .jlw-leader-name {
      font-size: 19px;
    }

    .jlw-leader-footer {
      align-items: flex-start;
      flex-direction: column;
    }

    .jlw-values-inner {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .jlw-value:nth-child(2) {
      border-right: 0;
    }

    .jlw-value:nth-child(-n+2) {
      border-bottom: 1px solid #e9ebef;
    }

    .jlw-closing {
      padding: 55px 22px 65px;
    }
  }

  /* PHONES */

  @media (max-width: 480px) {
    .jlw-hero {
      min-height: 330px;
      padding: 65px 19px 70px;
    }

    .jlw-eyebrow {
      gap: 8px;
      font-size: 9px;
      letter-spacing: 2px;
    }

    .jlw-hero h1 {
      font-size: 37px;
    }

    .jlw-hero-description {
      margin-top: 18px;
      line-height: 1.8;
    }

    .jlw-intro,
    .jlw-team-section {
      padding-right: 16px;
      padding-left: 16px;
    }

    .jlw-intro h2 {
      font-size: 30px;
    }

    .jlw-section-heading h2 {
      font-size: 32px;
    }

    .jlw-team-grid {
      grid-template-columns: 1fr;
      max-width: 370px;
      gap: 23px;
    }

    .jlw-leader-image-wrap {
      height: 340px;
    }

    .jlw-leader-content {
      padding: 24px 22px;
    }

    .jlw-leader-name {
      font-size: 23px;
    }

    .jlw-leader-footer {
      align-items: center;
      flex-direction: row;
    }

    .jlw-values {
      padding-right: 16px;
      padding-left: 16px;
    }

    .jlw-values-inner {
      grid-template-columns: 1fr;
    }

    .jlw-value,
    .jlw-value:nth-child(2) {
      border-right: 0;
      border-bottom: 1px solid #e9ebef;
    }

    .jlw-value:last-child {
      border-bottom: 0;
    }

    .jlw-closing {
      padding-right: 19px;
      padding-left: 19px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .jlw-leadership *,
    .jlw-leadership *::before,
    .jlw-leadership *::after {
      scroll-behavior: auto !important;
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

const StaffPage = () => {
  return (
    <main className="jlw-leadership">
      <style>{foundationStyles}</style>

      {/* HERO */}
      <section className="jlw-hero">
        <div className="jlw-hero-inner">
          <div className="jlw-hero-copy">
            <span className="jlw-eyebrow">
              Jana L. Williams Educational Foundation
            </span>

            <h1>
              Leadership That
              <span>Inspires Excellence.</span>
            </h1>

            <p className="jlw-hero-description">
              Meet the dedicated educational leaders working to nurture
              talent, strengthen learning, develop character, and create
              opportunities for every student to thrive.
            </p>
          </div>
        </div>

        <div className="jlw-hero-bottom" />
      </section>

      {/* INTRODUCTION */}
      <section className="jlw-intro">
        <div className="jlw-intro-inner">
          <div className="jlw-intro-symbol" aria-hidden="true">
            <div className="jlw-intro-emblem">
              <FaGraduationCap />
            </div>

            <span className="jlw-intro-caption">
              Education · Leadership · Opportunity
            </span>
          </div>

          <div className="jlw-intro-copy">
            <span className="jlw-section-label">
              The People Behind Our Purpose
            </span>

            <h2>
              Guided by Purpose.
              <br />
              United by Education.
            </h2>

            <p className="jlw-intro-text">
              Strong educational communities begin with strong leadership.
              Our leadership team works to support teachers, encourage
              students, strengthen educational standards, and foster an
              environment where learning and personal growth go hand in hand.
            </p>

            <p className="jlw-intro-text">
              Through collaboration, accountability, and a shared commitment
              to educational excellence, we strive to make a lasting
              difference in the lives of the learners and families we serve.
            </p>

            <div className="jlw-intro-rule" />
          </div>
        </div>
      </section>

      {/* LEADERSHIP TEAM */}
      <section className="jlw-team-section" id="leadership-team">
        <div className="jlw-section-heading">
          <span className="jlw-section-label">
            Our Leadership
          </span>

          <h2>Meet the Team</h2>

          <p>
            Experienced, committed, and student-focused leaders dedicated to
            supporting educational quality and building a positive learning
            community.
          </p>
        </div>

        <div className="jlw-team-grid">
          {schoolLeadershipTeam.map((leader, index) => (
            <article
              className="jlw-leader-card"
              key={leader.id}
            >
              <div className="jlw-leader-image-wrap">
                {leader.image ? (
                  <img
                    src={leader.image}
                    alt={`Portrait of ${leader.name}, ${leader.role}`}
                    className="jlw-leader-image"
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                ) : (
                  <div
                    className="jlw-leader-image-fallback"
                    aria-label={leader.name}
                  >
                    {leader.initials}
                  </div>
                )}

                <span className="jlw-leader-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="jlw-leader-role">
                  {leader.role}
                </span>
              </div>

              <div className="jlw-leader-content">
                <h3 className="jlw-leader-name">
                  {leader.name}
                </h3>

                <p className="jlw-leader-position">
                  {leader.role}
                </p>

                <div className="jlw-leader-divider" />

                <p className="jlw-leader-description">
                  {leader.description}
                </p>

                <div className="jlw-leader-footer">
                  <span className="jlw-contact-caption">
                    Get in touch
                  </span>

                  <div className="jlw-contact-links">
                    {leader.email && (
                      <a
                        className="jlw-contact-link"
                        href={`mailto:${leader.email}`}
                        aria-label={`Email ${leader.name}`}
                        title={`Email ${leader.name}`}
                      >
                        <FaEnvelope />
                      </a>
                    )}

                    {leader.phone && (
                      <a
                        className="jlw-contact-link"
                        href={`tel:${leader.phone.replace(
                          /[^\d+]/g,
                          ""
                        )}`}
                        aria-label={`Call ${leader.name}`}
                        title={`Call ${leader.name}`}
                      >
                        <FaPhoneAlt />
                      </a>
                    )}

                    {leader.linkedin && (
                      <a
                        className="jlw-contact-link jlw-linkedin"
                        href={leader.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${leader.name} on LinkedIn`}
                        title="LinkedIn profile"
                      >
                        <FaLinkedinIn />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* FOUNDATION VALUES */}
      <section
        className="jlw-values"
        aria-label="Our educational priorities"
      >
        <div className="jlw-values-inner">
          <div className="jlw-value">
            <div className="jlw-value-icon">
              <FaBookOpen />
            </div>

            <div>
              <h3>Quality Education</h3>
              <p>Meaningful learning experiences</p>
            </div>
          </div>

          <div className="jlw-value">
            <div className="jlw-value-icon">
              <FaAward />
            </div>

            <div>
              <h3>Academic Excellence</h3>
              <p>High standards and achievement</p>
            </div>
          </div>

          <div className="jlw-value">
            <div className="jlw-value-icon">
              <FaUsers />
            </div>

            <div>
              <h3>Student Development</h3>
              <p>Skills, confidence, and leadership</p>
            </div>
          </div>

          <div className="jlw-value">
            <div className="jlw-value-icon">
              <FaHeart />
            </div>

            <div>
              <h3>Community Impact</h3>
              <p>Building a brighter future together</p>
            </div>
          </div>
        </div>
      </section>

      {/* CLOSING MESSAGE */}
      <section className="jlw-closing">
        <div className="jlw-closing-inner">
          <FaQuoteLeft
            className="jlw-quote-icon"
            aria-hidden="true"
          />

          <h2>
            Every learner deserves the opportunity to discover their
            potential and build a brighter future.
          </h2>

          <p>
            Together, through dedicated leadership and a shared belief in
            education, we can inspire achievement, strengthen communities,
            and open doors to new opportunities.
          </p>

          <div className="jlw-closing-rule" />
        </div>
      </section>
    </main>
  );
};

export default StaffPage;
